(ns ycweb.app.website.registry.create
  (:require
   #?@(:clj
       [[clj-time.core :as dt]]
       :cljs
       [[cljs-time.core :as dt]])
   [ycweb.components.flow :as flow]
   [rum.core :as rum]
   [ycweb.util.core :as u]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.headings :as headings]
   [ycweb.app.website.website :as website]
   [ycweb.util.urlstate :as urlstate]
   [ycweb.components.grid :as grid]
   [ycweb.components.common :as cmn]
   [ycweb.components.transitions :as t]
   [ycweb.components.datepicker :as datepicker]
   [ycweb.util.comms :as comms]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.date :as ud]
   [ycweb.components.forms :as forms]
   [ycweb.components.feedback :as feedback]
   [util.string :as str]
   [ycweb.app.website.myaccount.common :as awm.common]
   [ycweb.app.website.auth.common :as auth.cmn]
   [ycweb.util.hash :as hash]
   [ycweb.components.appcommon :as appcommon]
   #?@(:clj [[clj-time.format :as dtfmt]])
   [ycweb.components.scroll :as scroll]))

;; -- REGISTRY CREATE --
(defn show-user-inputs? [user]
  (not
    (and
      (u/presence (:firstname user))
      (u/presence (:lastname user))
      user)))

(defn show-error-feedback [app-atom error-feedback]
  (let [registry-atom (rum/cursor (cmn/process-cursor app-atom) :registry)]
    (toaster/close-overlay app-atom :web.registry/create.create-save)
    (toaster/close-overlay app-atom :web.registry/create.createdetails)
    (toaster/open-toast app-atom :error error-feedback {})
    (swap! registry-atom assoc :registry/fail-validation-reason error-feedback)
    (scroll/scroll-to-id nil "js-display-validation-error")))

(defmethod grid/action :web.registry/create-account-check [app-atom {:keys [registry]} _]
  (let [user (cmn/curact app-atom [:user])
        user-email (cmn/curact registry [:registry/user :user/email])
        user-firstname (cmn/curact registry [:registry/user :user/first-name])
        user-lastname (cmn/curact registry [:registry/user :user/last-name])
        wedding-date (cmn/curact registry [:registry/close-date])
        error-feedback
        (cond
          (and (show-user-inputs? user) (not (u/presence user-firstname)))
          "Please enter a name."

          (and (show-user-inputs? user) (not (u/presence user-lastname)))
          "Please enter a surname."

          (and (show-user-inputs? user) (not (u/presence user-email)))
          "Please enter an email."

          (not (u/presence wedding-date))
          "Please enter a wedding date.")]

    (toaster/open-overlay app-atom :web.registry/create.create-save)
    (cond
      error-feedback
      (show-error-feedback app-atom error-feedback)

      :else
      (comms/ajax-get :web.registry/create-account-check {:user-email user-email}))))

(defn prompt-login-for-existing-account
  "The typed email already has an account with a password: send the visitor
   to log in instead of creating a registry under a duplicate account."
  [app-atom]
  (toaster/close-overlay app-atom :web.registry/create.create-save)
  (urlstate/redirect app-atom "registry" "create" {:afterloginredirect "/registry.htm?action=create"})
  (grid/open-modal app-atom
    :web.login/login-start
    {:config
     {:size :small
      :blur-bg? true
      :feedback-info "The email address you entered is already in use."
      :feedback-msg "Log into your account to continue."}}))

(defmethod comms/receive :web.registry/create-account-check [app-atom {:keys [account-exists?]}]
  (let [process-atom (cmn/process-cursor app-atom)
        registry (cmn/curact process-atom [:registry])
        logged-in-user (cmn/curact app-atom [:user])
        newsletter-sub (:newsletter/subscribe registry)
        newsletter-personalized (:newsletter/personalised registry)
        wedding-date (str (ud/date-format (:registry/close-date registry) "yyyy-MM-dd"))
        form-user (:registry/user registry)
        incomplete-registry (:incomplete-registry registry)]

    (cond
      (and
        (nil? logged-in-user)
        account-exists?)
      (prompt-login-for-existing-account app-atom)

      :else
      (grid/dispatch-action app-atom :web.registry/create.create-save
        {:registry/newsletter-sub newsletter-sub
         :registry/newsletter-personalized newsletter-personalized
         :user form-user
         :registry/wedding-date wedding-date
         :registry/event-type "Wedding"
         :session/php-session-id (get @app-atom :php-session-id)
         :client-order/id (:client-order/id incomplete-registry)
         :referrer (urlstate/current-url)
         :landing-page-session (last (str/split (urlstate/current-url) #"[a-z0-9-]+\.(?:com|org)(?:\.[a-z]{2,3})?"))}))))

(defmethod grid/action :web.registry/create.create-save [app-atom config _]
  (toaster/open-overlay app-atom :web.registry/create.create-save)
  (comms/ajax-post :web.registry/save-create config))

(defmethod comms/receive :web.registry/save-create [app-atom {:keys [error msg registry account-exists?]}]
  (let [{:ent/keys [uuid]} registry]
    (cond
      account-exists?
      (prompt-login-for-existing-account app-atom)

      error
      (show-error-feedback app-atom msg)

      :else
      (urlstate/raw-redirect app-atom (str "/registry.htm?action=createdetails&uuid=" uuid)))))

(rum/defcs registry-create-form < rum/reactive (cmn/local nil ::node-atom) [local-atom app-atom]
  (let [node-atom (::node-atom local-atom)
        {:keys [captcha-site-key]} (cmn/curact app-atom :config)
        process-atom (cmn/process-cursor app-atom)
        registry-atom (rum/cursor-in process-atom [:registry])
        newsletter-atom (rum/cursor-in registry-atom [:newsletter/subscribe])
        newsletter-selected (rum/react newsletter-atom)
        user (cmn/curact app-atom [:user])
        incomplete-registry (cmn/curact registry-atom :incomplete-registry)
        fail-validation-reason (cmn/curact registry-atom :registry/fail-validation-reason)]

    [:<>
     [:div.u-max-width-480.u-block-center
      (headings/heading "Create your Registry"
        {:type :h1
         :size :large
         :center true})
      [:p.yc-paragraph.u-text-center
       (if (:client-order/id incomplete-registry)
         "We see you've started a registry before but never completed your set-up. We need only a few more details from you."
         "We need only a few details for you to get started. Remember, setting up your registry is free.")]

      [:div.flex-grid-content
       {:id "js-display-validation-error"}
       (when fail-validation-reason
         (feedback/feedback :warning
           fail-validation-reason))]

      [:form.form
       {:ref (fn [node] (reset! node-atom node))}
       (when (show-user-inputs? user)
         [:<>
          (forms/split-input-field
            ["First name:" "e.g. Jane"
             (rum/cursor-in registry-atom
               [:registry/user :user/first-name])
             {:type :user
              :id :firstname
              :required? true}]
            ["Last name:" "e.g. Smith"
             (rum/cursor-in registry-atom
               [:registry/user :user/last-name])
             {:type :user
              :id :lastname
              :required? true}])
          [:div.form-field
           (forms/input "Email address:" "e.g. jane.smith@domain.com"
             (rum/cursor-in registry-atom
               [:registry/user :user/email])
             {:type :email
              :required? true
              :hide-email-helpers true})]])
       (datepicker/datepicker app-atom "Wedding date:" "Wedding date:"
         [:web.registry :registry :registry/close-date]
         {:required? true
          :hint
          [:span [:b "Note:"]
           " If you don't know your exact date, you can edit this later."]
          :min-date (ud/at-midnight (dt/minus (dt/now) (dt/days 1)))
          :has-icon true
          :field-classes "flush"
          :datatype :datedmy})

       [:div.form-field.toggle-label
        [:label.form-field.toggle-label
         [:input.toggle
          (forms/checkbox-props
            newsletter-atom
            #(swap! registry-atom assoc-in [:newsletter/personalised] @newsletter-atom)
            nil
            false
            false)]
         [:span.toggle__graphic-wrapper
          [:span.toggle__graphic]]
         [:span.toggle__text
          [:span.toggle__title "Newsletters and personalised offers"]
          [:span "Find out first about new launches and deals, plus the chance to receive occasional vouchers"]]]]

       [:div.form-field.toggle-label
        [:label.form-field.toggle-label
         [:input.toggle
          (forms/checkbox-props
            (rum/cursor-in registry-atom [:newsletter/personalised])
            nil
            nil
            newsletter-selected
            false)]
         [:span.toggle__graphic-wrapper
          [:span.toggle__graphic]]
         [:span.toggle__text
          [:span.toggle__title "Personalised offers only"]
          [:span "Sign up for the chance of occasional personalised vouchers, without getting our newsletters"]]]]
       [:div.form-control
        (buttons/button-web "Create Registry"
          {:type :button
           :style :primary
           :on-click
           (forms/form-validate node-atom
             #(appcommon/recaptcha app-atom captcha-site-key :web.registry/create-account-check {:registry registry-atom}))
           :size :default})
        [:p.yc-paragraph
         [:a
          {:on-click #(grid/dispatch-action app-atom :web.registry/help-setup-modal {})
           :class (u/bem :text-link [:muted])}
          "Help me set it up"]]
        [:p.yc-paragraph
         "By creating an account you are agreeing to our "
         [:a.text-link
          (urlstate/href-props app-atom "help" "article" {:id 71 :name "website-terms-and-conditions-of-use"})
          "terms and conditions"]
         ", and "
         [:a.text-link
          (urlstate/href-props app-atom "help" "article" {:id 191 :name "mr-price-group-limited-privacy-policy"})
          "privacy policy"]
         "."]]]

      (toaster/loading-overlay app-atom :web.registry/create.create-save)]]))

(rum/defc registry-create < rum/reactive [app-atom]
  [:main
   {:class (u/bem :yc-page-content [:standard])}
   [:div
    {:class (u/bem :yc-section [:large])}
    (registry-create-form app-atom)]])

(defmethod flow/render-screen :web.registry/create [app-atom _]
  (website/screen-wrapper app-atom
    (registry-create app-atom)
    {:pagetype :registry}))

(defmethod t/transition-open :web.registry/create [app-atom _ _]
  (let [user (cmn/curact app-atom [:user])]
    (when user
      (toaster/open-overlay app-atom :web.registry/create.create-save)
      (comms/ajax-get :web.registry/existing-registry-check {}))
    (swap! (rum/cursor (cmn/process-cursor app-atom) :registry) dissoc :registry/fail-validation-reason)))

(defmethod comms/receive :web.registry/existing-registry-check [app-atom {:keys [incomplete-registry]}]
  (let [user (cmn/curact app-atom [:user])]
    (swap! (cmn/process-cursor app-atom) assoc-in
      [:registry]
      {:incomplete-registry incomplete-registry
       :registry/user
       {:user/email (:email user)
        :user/first-name (:firstname user)
        :user/last-name (:lastname user)}
       :registry/close-date (:registry/close-date incomplete-registry)})
    (toaster/close-overlay app-atom :web.registry/create.create-save)))
;; -- REGISTRY CREATE END --

;; -- REGISTRY DETAILS --
(defmethod grid/action :web.registry/create-details-validation [app-atom _ _]
  (let [process-atom (cmn/process-cursor app-atom)
        registry-atom (rum/cursor-in process-atom [:registry])
        create-details (cmn/curact registry-atom :create-details)
        {:create-details/keys [has-pwd? has-tel?]} create-details
        {:registry/keys [user nearest-city partner]} @registry-atom
        {:user/keys [password password-confirmation tel]} user
        {:partner/keys [first-name last-name email]} partner
        pwd-val (:value password)
        pwd-cnf-val (:value password-confirmation)
        hashed-pwd-user
        (assoc user
          :user/password
          (when (u/presence pwd-val)
            (hash/md5 pwd-val))
          :user/password-confirmation
          (when (u/presence pwd-cnf-val)
            (hash/md5 pwd-cnf-val)))
        val-error
        (auth.cmn/validate-password
          (:user/password hashed-pwd-user)
          (:user/password-confirmation hashed-pwd-user)
          (count pwd-val) {})

        error-feedback
        (cond
          (and
            (not has-tel?)
            (not (u/presence tel)))
          "Please enter a tel number."

          (and
            (not has-pwd?)
            (not (u/presence pwd-val)))
          "Please enter a password."

          (and
            (not has-pwd?)
            (not (empty? (:user/password val-error))))
          (str (first (:user/password val-error)))

          (and
            (not has-pwd?)
            (not (u/presence pwd-cnf-val)))
          "Please enter a password confirmation."

          (not= pwd-val pwd-cnf-val)
          "Passwords do not match."

          (empty? nearest-city)
          "Please select a city."

          (not (u/presence first-name))
          "Please enter your partner's first name."

          (not (u/presence last-name))
          "Please enter your partner's last name."

          (not (u/presence email))
          "Please enter your partner's email.")]

    (cond
      error-feedback
      (show-error-feedback app-atom error-feedback)

      :else
      (grid/dispatch-action app-atom :web.registry/create.save-create-details
        {:user hashed-pwd-user
         :partner partner
         :create-details create-details
         :nearest-city nearest-city}))))

(defmethod grid/action :web.registry/create.save-create-details [app-atom config _]
  (toaster/open-overlay app-atom :web.registry/create.createdetails "Getting you started!")
  (comms/ajax-post :web.registry/save-create-details config))

(defmethod comms/receive :web.registry/save-create-details [app-atom {:keys [success registry]}]
  (let [process-atom (cmn/process-cursor app-atom)
        {:ent/keys [uuid]} registry]
    (cond
      success
      (do
        (swap! process-atom dissoc :registry)
        (toaster/close-overlay app-atom :web.registry/create.createdetails)
        (urlstate/redirect app-atom "registry" "edit" {:uuid uuid}))

      :else
      (toaster/open-toast app-atom :error
        "There was an error setting up your Registry, please try again or contact Customer Support" {}))))

(rum/defcs registry-create-details < rum/reactive cmn/cursors (cmn/local nil ::node-atom) [local-atom app-atom]
  (let [node-atom (::node-atom local-atom)
        process-atom (cmn/process-cursor app-atom)
        registry-atom (rum/cursor-in process-atom [:registry])
        {:create-details/keys [order-id has-tel? has-pwd?]} (cmn/curact registry-atom :create-details)
        fail-validation-reason (cmn/curact registry-atom :registry/fail-validation-reason)]
    [:<>
     [:div
      {:class (u/bem :yc-page-content [:standard])}
      [:div
       {:class (u/bem :yc-section [:large])}
       [:div.u-max-width-480.u-block-center
        (headings/heading "Thank you. Now let's complete your registry setup."
          {:type :h1
           :size :large
           :center true})
        [:p.yc-paragraph.u-text-center
         [:b
          {:class (u/bem :text-status [:success])}
          "Your registry is ready"]
         (str
           " and your reference number is YC"
           order-id ", but we need a few more details to get you all set up.")]

        [:div.flex-grid-content
         {:id "js-display-validation-error"}
         (when fail-validation-reason
           (feedback/feedback :error
             fail-validation-reason))]

        [:form.form
         {:ref (fn [node] (reset! node-atom node))}
         [:div.form-section
          (headings/heading "Your Details"
            {:type :h2
             :size :tiny})
          [:div.form-field
           [:label.form-label
            {:id "nearestcity" :name "nearestcity"}
            "Your nearest city:"]
           [:div.select-wrapper
            (forms/select-raw
              (rum/cursor registry-atom :registry/nearest-city)
              [{:value "" :text "- Please select -"}
               {:value "Bloemfontein" :text "Bloemfontein"}
               {:value "Cape Town" :text "Cape Town"}
               {:value "Durban" :text "Durban"}
               {:value "East London" :text "East London"}
               {:value "Johannesburg" :text "Johannesburg"}
               {:value "Pietermaritzburg" :text "Pietermaritzburg"}
               {:value "Port Elizabeth" :text "Port Elizabeth"}
               {:value "Pretoria" :text "Pretoria"}
               {:value "Other City or Town" :text "Other City or Town"}])]
           [:div.form-hint-wrapper
            [:span.form-hint
             [:b "Note:"]
             " We only ship within South Africa"]]]
          (when-not has-tel?
            [:div.form-field
             (forms/input "Your mobile number" "e.g. 083 000 0000"
               (rum/cursor-in registry-atom [:registry/user :user/tel])
               {:type :phone
                :id :usertel
                :name :usertel
                :required? true
                :hint
                (list [:b "Note:"] " We need this in case your email address is not reachable")})])
          (when-not has-pwd?
            (list
              [:div.form-field
               (forms/password-input "Create a password:" "Password"
                 (rum/cursor-in registry-atom [:registry/user :user/password])
                 {:hint "Must be at least 8 characters and 1 special character or number"
                  :yc-input? true
                  :required? true})]
              [:div.form-field
               (forms/password-input "Confirm password:" "Confirm password"
                 (rum/cursor-in registry-atom [:registry/user :user/password-confirmation])
                 {:yc-input? true
                  :required? true})]))]
         [:div.form-section
          (headings/heading "Your partner's details"
            {:type :h2
             :size :tiny})
          (forms/split-input-field
            ["Partner's first name:" "e.g. John"
             (rum/cursor-in registry-atom [:registry/partner :partner/first-name])
             {:type :user
              :id :partnersfirstname
              :name :partnersfirstname
              :required? true}]
            ["Partner's last name:" "e.g. Taylor"
             (rum/cursor-in registry-atom [:registry/partner :partner/last-name])
             {:type :user
              :id :partnerslastname
              :name :partnerslastname
              :required? true}])
          [:div.form-field

           (forms/input "Partner's email address:" "john.taylor@domain.com"
             (rum/cursor-in registry-atom [:registry/partner :partner/email])
             {:type :email
              :icon? true
              :id :partnersemail
              :name :partnersemail
              :required? true
              :hide-email-helpers true})]
          [:div.form-field
           (forms/input "Partner's mobile number:" "e.g. 083 000 0000"
             (rum/cursor-in registry-atom [:registry/partner :partner/tel])
             {:type :phone
              :id :partnertel
              :name :partnerstel})]]
         [:div.form-control
          (buttons/button-web "Submit"
            (merge
              (urlstate/href-on-click
                (forms/form-validate node-atom
                  #(grid/dispatch-action app-atom :web.registry/create-details-validation {})))
              {:type :button
               :style :primary
               :size :default}))
          [:p
           {:class (u/bem :yc-paragraph [:flush])}
           [:a
            {:on-click #(grid/dispatch-action app-atom :web.registry/help-setup-modal {})
             :class (u/bem :text-link [:muted])}
            "Help me set it up"]]]]]
       (toaster/loading-overlay app-atom :web.registry/create.createdetails)]]]))

(defmethod flow/render-screen :web.registry/createdetails [app-atom _]
  (website/screen-wrapper app-atom
    (registry-create-details app-atom)
    {:pagetype :registry}))

(defmethod t/transition-open :web.registry/createdetails [app-atom _ {:keys [uuid]}]
  (comms/ajax-get :web.registry/existing-user-details-check
    {:registry {:ent/uuid uuid}})
  (toaster/open-overlay app-atom :web.registry/createdetails))

(defmethod comms/receive :web.registry/existing-user-details-check [app-atom {:keys [create-details]}]
  (toaster/close-overlay app-atom :web.registry/createdetails)
  (let [process-atom (cmn/process-cursor app-atom)]
    (swap! process-atom assoc-in [:registry :create-details] create-details)))

(defmethod grid/action :web.registry/help-setup-modal [app-atom _ _]
  (grid/open-modal app-atom :web.registry/help-setup-modal
    {:config
     {:title "Help Setup"}}))

(rum/defc create-password-action [app-atom]
  [:<>
   [:div
    {:class (u/bem :yc-page-content [:standard])}
    [:div
     {:class (u/bem :yc-section [:large])}
     [:div.u-block-center
      (headings/heading "Recover your password"
        {:type :h1
         :size :medium})
      (feedback/feedback :info "Success!"
        [:span "Your password has been successfully changed. Head over to the
         " [:a (urlstate/href-props app-atom "registry") "registries home page"] "
          to log in using your new details."])]]]])

(defmethod flow/render-screen :web.registry/createPasswordAction [app-atom _]
  (website/screen-wrapper app-atom
    (create-password-action app-atom)
    {:pagetype :registry}))
